var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManypixelsSchoolOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_88_knowledge_outline",
    "data-name": "#88_knowledge_outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.58,101.65l-4.46,15.9C229,122.72,200,154.41,200,154.41s-30.85-33.7-80.58-37.26v-15.5l-8,19.42v95.49S165,207.66,200,237.92c35-30.26,88.58-21.36,88.58-21.36V121.07Z",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,238.92a1,1,0,0,1-.65-.25c-34.3-29.61-87.23-21.21-87.77-21.12a1,1,0,0,1-.81-.23,1,1,0,0,1-.35-.76V121.07a1,1,0,0,1,.07-.38l8-19.42a1,1,0,0,1,1.12-.6,1,1,0,0,1,.81,1v14.57C165.26,119.79,195,148,200,153c4.82-4.87,32.87-31.45,75.34-36.35l4.28-15.25a1,1,0,0,1,.91-.73,1,1,0,0,1,1,.62l8,19.42a1,1,0,0,1,.08.38v95.49a1,1,0,0,1-.35.76,1,1,0,0,1-.81.23c-.54-.09-53.49-8.47-87.77,21.12A1,1,0,0,1,200,238.92Zm-70.51-24.53c18.76,0,48.3,3.46,70.51,22.21,32.12-27.11,79.57-22.24,87.58-21.19V121.27l-6.82-16.56-3.68,13.11a1,1,0,0,1-.85.72c-46.17,5.07-75.2,36.24-75.49,36.55a1,1,0,0,1-1.48,0c-.3-.33-31.17-33.45-79.91-36.94a1,1,0,0,1-.93-1V106.7l-6,14.57v94.14A133.73,133.73,0,0,1,129.49,214.39Zm146.63-96.84h0Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,227.69v-88.6s-31.27-40.18-80.58-37.44v103.2S168.12,195.32,200,227.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,228.69a1,1,0,0,1-.71-.3c-31.12-31.6-79.2-22.66-79.68-22.56a1,1,0,0,1-1.19-1V101.65a1,1,0,0,1,.94-1c49.28-2.77,81.11,37.42,81.43,37.82a1,1,0,0,1,.21.62v88.6a1,1,0,0,1-1,1ZM135.86,202.6c16.79,0,43,3.57,63.14,22.7V139.44c-2.8-3.42-33-38.89-78.58-36.84V203.67A104.82,104.82,0,0,1,135.86,202.6Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,227.69v-88.6s31.27-40.18,80.58-37.44v103.2S231.88,195.32,200,227.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,228.69a1,1,0,0,1-1-1v-88.6a1,1,0,0,1,.21-.62c.32-.4,32.13-40.58,81.43-37.82a1,1,0,0,1,.94,1v103.2a1,1,0,0,1-.36.77,1,1,0,0,1-.83.21c-.48-.1-48.56-9-79.68,22.56A1,1,0,0,1,200,228.69Zm1-89.25V225.3c29.07-27.67,71-22.79,78.58-21.63V102.6C234,100.56,203.8,136,201,139.44Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,147a1,1,0,0,1-.68-.27c-27-25.25-54.37-23.5-54.64-23.48a1,1,0,1,1-.15-2c.28,0,28.45-1.87,56.16,24a1,1,0,0,1,.05,1.41A1,1,0,0,1,189,147Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,164.64a1,1,0,0,1-.68-.27c-27-25.25-54.37-23.5-54.64-23.48a1,1,0,0,1-.15-2c.28,0,28.46-1.87,56.16,24a1,1,0,0,1,.05,1.41A1,1,0,0,1,189,164.64Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,182.28a1,1,0,0,1-.68-.27c-27-25.24-54.37-23.5-54.64-23.48a1,1,0,0,1-.15-2c.28,0,28.46-1.87,56.16,24a1,1,0,0,1,.05,1.41A1,1,0,0,1,189,182.28Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,199.92a1,1,0,0,1-.68-.27c-27-25.24-54.37-23.5-54.64-23.48a1,1,0,0,1-.15-2c.28,0,28.46-1.87,56.16,24a1,1,0,0,1,.05,1.41A1,1,0,0,1,189,199.92Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,147a1,1,0,0,1-.73-.32,1,1,0,0,1,0-1.41c14.46-13.51,28.93-19.32,38.52-21.82,10.43-2.71,17.35-2.22,17.64-2.19a1,1,0,0,1,.92,1.07,1,1,0,0,1-1.07.92c-.27,0-27.61-1.77-54.64,23.48A1,1,0,0,1,211,147Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,164.64a1,1,0,0,1-.73-.32,1,1,0,0,1,0-1.41c14.46-13.51,28.93-19.32,38.52-21.81,10.43-2.72,17.35-2.22,17.64-2.2a1,1,0,0,1,.92,1.07,1,1,0,0,1-1.07.92c-.27,0-27.61-1.77-54.64,23.48A1,1,0,0,1,211,164.64Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,182.28a1,1,0,0,1-.73-.32,1,1,0,0,1,0-1.41c14.46-13.51,28.93-19.32,38.52-21.81,10.43-2.72,17.35-2.22,17.64-2.2a1,1,0,0,1,.92,1.07,1,1,0,0,1-1.07.92c-.27,0-27.62-1.76-54.64,23.48A1,1,0,0,1,211,182.28Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,199.92a1,1,0,0,1-.73-.32,1,1,0,0,1,0-1.41c14.46-13.51,28.93-19.32,38.52-21.81,10.43-2.72,17.35-2.22,17.64-2.2a1,1,0,0,1,.92,1.07,1,1,0,0,1-1.07.92c-.27,0-27.62-1.76-54.64,23.48A1,1,0,0,1,211,199.92Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,238.92a1,1,0,0,1-1-1V227.69a1,1,0,0,1,2,0v10.23A1,1,0,0,1,200,238.92Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.58,217.56a1,1,0,0,1-.83-.44l-8-11.71a1,1,0,1,1,1.65-1.13l8,11.72a1,1,0,0,1-.27,1.39A1,1,0,0,1,288.58,217.56Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.42,217.56a1,1,0,0,1-.56-.17,1,1,0,0,1-.27-1.39l8-11.72a1,1,0,1,1,1.65,1.13l-8,11.71A1,1,0,0,1,111.42,217.56Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.63,
    cy: 177.37,
    rx: 11.31,
    ry: 7.93,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,186.31c-6.78,0-12.3-4-12.3-8.93s5.52-8.94,12.3-8.94,12.31,4,12.31,8.94S207.42,186.31,200.63,186.31Zm0-15.87c-5.68,0-10.3,3.11-10.3,6.94s4.62,6.93,10.3,6.93,10.31-3.11,10.31-6.93S206.32,170.44,200.63,170.44Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,112.67a33.43,33.43,0,1,0-58.36,22.27,37.77,37.77,0,0,1,9.69,21.8v0h30.46v0a35.79,35.79,0,0,1,9.22-21.29A33.25,33.25,0,0,0,233.92,112.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.72,157.77H185.26a1,1,0,0,1-1-.91,36.58,36.58,0,0,0-9.44-21.25,34.43,34.43,0,1,1,50.86.53,34.84,34.84,0,0,0-9,20.69A1,1,0,0,1,215.72,157.77Zm-29.56-2h28.66a36.8,36.8,0,0,1,9.39-21,32.43,32.43,0,1,0-47.9-.5A38.67,38.67,0,0,1,186.16,155.77Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,157.77a1,1,0,0,1-1-1c0-.21,0-15.64-2-26.31a26.17,26.17,0,0,1-9.47-3.92c-3-2.07-4.66-4.49-4.6-6.62.08-2.44,1.26-4.23,3.18-4.79,3-.87,6.82,1.38,9.79,5.73a23.47,23.47,0,0,1,2.78,7.88,28.26,28.26,0,0,0,9.21-.08c2.05-7.88,4.95-13.87,7.8-14.44a6.32,6.32,0,0,1,7,4.39c.43,1.46,1.15,6.47-7.86,10.13a32.55,32.55,0,0,1-5.22,1.63c-1.88,7.71-3.08,17.3-2.35,25.38a1,1,0,1,1-2,.18,84.86,84.86,0,0,1,2.15-25.17,30.34,30.34,0,0,1-8.29.05c1.88,10.76,1.91,25.12,1.91,26A1,1,0,0,1,197.32,157.77Zm-12.55-40.83a2.7,2.7,0,0,0-.77.11c-1.45.42-1.71,2-1.74,2.93,0,1.4,1.39,3.29,3.74,4.92a23.59,23.59,0,0,0,7.89,3.42,19.31,19.31,0,0,0-2.31-6.33C189.15,118.42,186.55,116.94,184.77,116.94Zm29.27-.82a3.18,3.18,0,0,0-.62.06c-1.8.36-4.12,5.24-6,12a31.33,31.33,0,0,0,3.91-1.29c5-2,7.52-4.92,6.69-7.7A4.43,4.43,0,0,0,214,116.12Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.3,
    y: 155.84,
    width: 34.66,
    height: 23.22,
    rx: 2.47,
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,180.06H185.77a3.48,3.48,0,0,1-3.47-3.47V158.31a3.48,3.48,0,0,1,3.47-3.47H215.5a3.48,3.48,0,0,1,3.47,3.47v18.28A3.48,3.48,0,0,1,215.5,180.06Zm-29.73-23.22a1.47,1.47,0,0,0-1.47,1.47v18.28a1.47,1.47,0,0,0,1.47,1.47H215.5a1.47,1.47,0,0,0,1.47-1.47V158.31a1.47,1.47,0,0,0-1.47-1.47Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,164.27H183.79a1,1,0,0,1,0-2h33.69a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,172.63H183.79a1,1,0,1,1,0-2h33.69a1,1,0,1,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.44,100a.92.92,0,0,1-.36-.07L149.43,95a1,1,0,0,1,.72-1.87L162.8,98a1,1,0,0,1-.36,1.93Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.49,78.32a1,1,0,0,1-.76-.35l-8.22-9.65A1,1,0,1,1,169,67l8.22,9.66a1,1,0,0,1-.76,1.64Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,100A1,1,0,0,1,237.2,98l12.65-4.87a1,1,0,0,1,1.29.58,1,1,0,0,1-.57,1.29L237.92,99.9A.92.92,0,0,1,237.56,100Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,78.32a1,1,0,0,1-.76-1.64L231,67a1,1,0,0,1,1.52,1.3L224.27,78A1,1,0,0,1,223.51,78.32Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,73.63a1,1,0,0,1-1-1V62.08a1,1,0,1,1,2,0V72.63A1,1,0,0,1,200,73.63Z",
    fill: "#dfeaef"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManypixelsSchoolOutline);
export default __webpack_public_path__ + "static/media/Manypixels_School_Outline.165b860dff7ecb0cd75ebf87c9773cf5.svg";
export { ForwardRef as ReactComponent };